import * as React from "react";
import { LocalReaderSession, type LocalReaderPolicy } from "./session";

const Context = React.createContext<LocalReaderSession | null>(null);
export function LocalReaderProvider({
  children,
  policy,
}: {
  children: React.ReactNode;
  policy?: Partial<LocalReaderPolicy>;
}) {
  const [session] = React.useState(() => new LocalReaderSession(policy));
  React.useEffect(() => () => session.disconnect(), [session]);
  return <Context.Provider value={session}>{children}</Context.Provider>;
}
export function useLocalReader() {
  const session = React.useContext(Context);
  if (!session)
    throw new Error(
      "Local reader requires the authenticated workspace provider"
    );
  const state = React.useSyncExternalStore(
    session.subscribe,
    session.getSnapshot,
    session.getSnapshot
  );
  return { ...state, session };
}
